import { render, staticRenderFns } from "./SocialMediaImageForm.vue?vue&type=template&id=8a91d660&scoped=true"
import script from "./SocialMediaImageForm.vue?vue&type=script&lang=js"
export * from "./SocialMediaImageForm.vue?vue&type=script&lang=js"
import style0 from "./SocialMediaImageForm.vue?vue&type=style&index=0&id=8a91d660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a91d660",
  null
  
)

export default component.exports